import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=106cf8c2&scoped=true"
import script from "./PageHeading.vue?vue&type=script&lang=js"
export * from "./PageHeading.vue?vue&type=script&lang=js"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=106cf8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cf8c2",
  null
  
)

export default component.exports